const Sex = {
    MEN: 'M',
    WOMEN: 'F'
}

export default Sex;